// extracted by mini-css-extract-plugin
module.exports = {"keyBioHighlights":"keyBioHighlights_keyBioHighlights__E7sln"};